const paragraph = document.querySelector('.prod-desc p');
const ul = document.querySelector('.prod-feat ul');

paragraph.classList.add('desc', 'hidden');
ul.classList.add('feat', 'hidden');


toggleContent('.desc-header', '.desc')
toggleContent('.feat-header', '.feat')
addKeydownOnFocus()
changeVariantLabelText();


function toggleContent(headerSelector, contentSelector) {
    const header = document.querySelector(headerSelector);
    const content = document.querySelector(contentSelector);
    header.addEventListener('click', () => {
      if (window.innerWidth < 1166) {
        content.classList.toggle('hidden')
        header.classList.toggle('active')
      }
    });
}

function changeVariantLabelText() {
  const variantWrapper = document.querySelectorAll('.variant-wrapper');
  for (let i = 1; i < variantWrapper.length; i++) {
    variantWrapper[i].addEventListener('change', (e) => {
      for (let j = 1; j < variantWrapper.length; j++) {
        const variantLabel = variantWrapper[j].querySelector('.variant__label-info span');
        const selectedVariantText = variantWrapper[j].querySelector('.variant-input-wrap input[type=radio]:checked+label').textContent;
        variantLabel.textContent = selectedVariantText;
      }
    });
  }
}

function addKeydownOnFocus() {
  const variants = document.querySelectorAll('.variant-input label');
  variants.forEach(variant => {
    variant.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.target.click();
      }
    });
  })
}